import { render, staticRenderFns } from "./selectPermissionTreeDialog.vue?vue&type=template&id=2c54697c&scoped=true"
import script from "./selectPermissionTreeDialog.vue?vue&type=script&lang=js"
export * from "./selectPermissionTreeDialog.vue?vue&type=script&lang=js"
import style0 from "./selectPermissionTreeDialog.vue?vue&type=style&index=0&id=2c54697c&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c54697c",
  null
  
)

export default component.exports